import React, { useState, useRef, useEffect } from "react";
// import { getReadableTripStatus } from '../../../../constants/app';
// import { getDateTimeFormatted } from '../../../../functions/dateAndTime';
import { Feather } from "react-feather";
import TripServices from "../../services/externalServices/trip/TripServices";
import {
  InfoRoute,
  InfoVehicles,
  InfoPayment,
  InfoOTP,
  InfoEndOTP,
  InfoFeedback,
  InfoHelpOptions,
  InfoDateAmount,
} from "./components";
// import DownloadInvoice from './DownloadInvoice';
import { useParams } from "react-router-dom";
import sendToWhatsApp from "../../utils/functions/WhatsAppUtils";
import { getDateTimeFormatted } from "../../utils/functions/dateAndTime";

function TripDetail({ item }) {
  const bottomSheetRef = useRef(null);
  const [currentSnapIndex, setCurrentSnapIndex] = useState(0);
  const [snapTo] = useState(["51%", "95%"]);
  const [isLoading, setIsLoading] = useState(true);
  const [tripData, setTripData] = useState(null);
  const [downloadModal, setDownloadModal] = useState(false);
  const { tripId } = useParams();
  const packageDetails = tripData?.bid?.cab_request;
  const cruzeId = tripData?.bid?.cab_request?.cruzeId;

  //   const tripId = item?.id;
  console.log("packageDetails", tripData?.bid?.cab_request);
  useEffect(() => {
    const fetchCompleteTripData = async (tripId) => {
      try {
        if (tripId && !tripData) {
          setIsLoading(true);
          const res = await TripServices.getTripByIdPopulateAllData(tripId);
          console.log("getTripByIdPopulateAllData", res.trip.is_user_rated);
          setTripData(res.trip);
        }
      } catch (error) {
        alert("Something went wrong! Please try again later.");
        console.error("Error fetching trip data:", error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchCompleteTripData(tripId);
    // const timeoutId = setTimeout(() => fetchCompleteTripData(tripId), 200);
    // return () => clearTimeout(timeoutId);
  }, [tripId]);

  const handleSendMessage = (messageType) => {
    sendToWhatsApp(
      messageType,
      tripData?.id,
      tripData?.rider.vehicle_number.toUpperCase(),
      tripData?.rider.vehicle_name,
      getDateTimeFormatted(tripData?.created_at, "FORMAT6"),
      getDateTimeFormatted(tripData?.trip_start_time, "FORMAT4"),
      getDateTimeFormatted(tripData?.trip_end_time, "FORMAT4")
    );
  };

  const handleDownloadInv = () => setDownloadModal(true);
  const handleDecline = () => setDownloadModal(false);

  if (isLoading) {
    return (
      <div className="flex-1 items-center justify-center bg-white">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500" />
        <p className="mt-4 text-gray-600">Loading your trip details...</p>
      </div>
    );
  }

  if (!tripData) return null;

  if (!tripData?.bid?.cab_request) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-white p-6 text-center text-gray-600">
        Trip details unavailable
      </div>
    );
  }

  const { rider, bid, status, pricing, paymentDetails } = tripData;
  const { cab_request } = bid || {};
  const tripStatus =
    paymentDetails?.state === "COMPLETED" ? status : "CANCELLED";
  const { requestedCruze } = cab_request;

  const cruzeType = requestedCruze ? requestedCruze : "CAR";

  console.log("tripData", tripData);
  console.log("package", packageDetails);
  return (
    <div className="flex-1 bg-white mt-10 pt-6">
      <div className="p-4">
        <h1 className="text-2xl font-bold text-gray-800 mb-2">
          {tripData?.tripTitle || "Ride with Cruze"}
        </h1>

        <div className="mb-4">
          <h2 className="text-lg font-semibold text-gray-700">
            Invoice# CZ-{tripData?.invoiceNumber}
          </h2>
          <p className="text-sm text-gray-500">
            {/* {getReadableTripStatus(tripStatus)} */}
          </p>
        </div>

        <InfoDateAmount
          bookedDateTime={tripData.created_at}
          tripStatus={tripStatus}
          cancelledBy={tripData.cancelledBy}
          tripDate={cab_request?.tripDate}
          tripTime={cab_request?.tripTime}
          tripFare={pricing?.finalAmount}
          thumbnailImage={tripData?.tripThumbnail}
          backgroundType={packageDetails?.backgroundType}
          backgroundURL={packageDetails?.backgroundURL}
        />

        <div className="my-4 h-px bg-gray-200" />

        <InfoRoute pickupLocation={cab_request?.pickup_location} />

        <div className="my-4 h-px bg-gray-200" />

        {/* <InfoVehicles
          driverAvatarUrl={rider?.avatar_url}
          driverName={`${rider?.first_name} ${rider?.last_name}`}

          vehicleNumber={rider?.vehicle_number}
          vehicleModel={rider?.vehicle_name}
          driverPhoneNo={rider?.phone_number}
        /> */}

        <InfoVehicles
          // headerText={cab_request.otp}
          // headerText={i18n.t('RIDE')}
          driverAvatarUrl={rider?.avatar_url}
          driverName={`${rider?.first_name} ${rider?.last_name}`}
          driverRatings={rider?.rating.toFixed(1)}
          vehicle={cruzeType}
          vehicleURL={""}
          vehicleNumber={rider?.vehicle_number}
          vehicleModel={rider?.vehicle_name}
          vehicleColor={"Standard"}
          showRatings={tripData?.is_user_rated}
          ratings={rider?.rider_rating}
          showPhoneNumber={true}
          driverPhoneNo={rider?.phone_number}
        />

        <div className="my-4 h-px bg-gray-200" />

        <InfoPayment pricing={pricing} paymentDetails={paymentDetails} />

        <div className="my-4 h-px bg-gray-200" />

        {/* <InfoOTP otpNumber={tripData.startOtp?.toString()} />
        <InfoEndOTP otpNumber={tripData.endOtp?.toString()} /> */}
        <div className="flex flex-col md:flex-row gap-4">
          <div className="w-full md:w-1/2">
            <InfoOTP otpNumber={tripData.startOtp?.toString()} />
          </div>

          <div className="w-full md:w-1/2">
            <InfoEndOTP otpNumber={tripData.endOtp?.toString()} />
          </div>
        </div>

        <InfoFeedback
          tripId={tripData.id}
          isRated={tripData?.is_user_rated}
          currentRating={tripData?.user_rating}
        />

        {/* <InfoHelpOptions
          showDownload={tripStatus === "TRIP_ENDED"}
          onDownload={handleDownloadInv}
          onFindLostItem={() => handleSendMessage("lostItem")}
          onPaymentIssue={() => handleSendMessage("paymentIssue")}
          onChat={() => handleSendMessage("chatWithUs")}
        /> */}

        <InfoHelpOptions
          showDownload={tripData?.status === "TRIP_ENDED" ? true : false}
          // showDownload={true}
          actionDownload={() => handleDownloadInv("downloadInvoice")}
          showFindLostItem={tripData?.status === "TRIP_ENDED" ? true : false}
          actionFindLostItem={() => handleSendMessage("lostItem")}
          showIssueWithPayment={true}
          actionIssueWithPayment={() => handleSendMessage("paymentIssue")}
          showChatWithUs={true}
          actionChatWithUs={() => handleSendMessage("chatWithUs")}
        />
      </div>

      {downloadModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center">
          <div className="bg-white rounded-lg p-6 max-w-md w-full">
            {/* <DownloadInvoice
              tripId={tripId}
              email={item?.user?.email}
              onClose={handleDecline}
            /> */}
          </div>
        </div>
      )}
    </div>
  );
}

export default React.memo(TripDetail);
